import classNames from "classnames";
import { toast } from "react-toastify";

import "$components/rebel-group/rebel-group.scss";

const RebelGroupButton = ({ disabled, onClick }) => {
    const handleOnClick = () => {
        if (!disabled && onClick) {
            onClick();
        } else {
            toast("This opportunity has already been sent to the CRM");
        }
    };
    const disabledText = disabled ? "This opportunity has already been sent to the CRM" : "Send to CRM";
    return (
        <button className={classNames("button -text", { "-disabled": disabled })} onClick={handleOnClick} title={disabledText}>
            <span className="rg-mark">RG</span>
        </button>
    );
};

export default RebelGroupButton;
